import React, { useRef } from 'react';
import css from './Radio.module.css';
import { ValidationMessage } from '../../components';
import { Paragraph } from '../../../text';
import clsx from 'clsx';

export interface RadioProps {
  groupName: string;
  value: string | number;
  checked?: boolean;
  label?: string;
  errorMessage?: string;
  showAsError?: boolean;
  disabled?: boolean;
  hideFocus?: boolean;
  onCheckChange: () => void;
}

const Radio: React.FC<RadioProps> = (props: RadioProps) => {
  const {label = undefined} = props;
  const baseInput = useRef<HTMLInputElement>(null);

  const onClickContainer = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (props.disabled) {
      return;
    }

    baseInput.current?.focus();
    e.stopPropagation();
    props.onCheckChange();
  };

  return (
    <div className={css.component}>
      <div
        className={clsx(
          css.container,
          props.disabled ? css.containerDisabled : null,
          props.errorMessage || props.showAsError ? css.containerError : null,
          props.hideFocus ? css.hideFocus : null
        )}
        onClick={onClickContainer}
      >
        <div className={css.radioContainer}>
          <input
            ref={baseInput}
            type="radio"
            name={props.groupName}
            disabled={props.disabled}
            className={css.radio}
            checked={props.checked}
            value={props.value}
            onChange={() => {
              return;
            }}
          />
          <span className={css.radiomark} />
        </div>
        {label && (
          <div className={css.labelContainer}>
            <Paragraph
              className={clsx(props.disabled ? css.labelDisabled : null)}
              text={label}
            />
          </div>
        )}
      </div>
      {props.errorMessage ? (
        <div className={css.messageContainer}>
          <ValidationMessage errorMessage={props.errorMessage} />
        </div>
      ) : null}
    </div>
  );
};

export default Radio;
